import { CreateTagReq, UpdateTagReq } from '../dto/ReqDtoRepository';
import { SimpleStringResponse, TagListResponse, TagResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';

export const getVenueTagList = async (): Promise<TagListResponse> =>
  sendGetApiRequest<TagListResponse>('/api/v1/venue-tag/list');

export const createVenueTag = async (data: CreateTagReq): Promise<TagResponse> =>
  sendApiRequest<TagResponse>('post', '/api/v1/venue-tag', data);

export const updateVenueTag = async (data: UpdateTagReq): Promise<TagResponse> =>
  sendApiRequest<TagResponse>('put', '/api/v1/venue-tag', data);

export const deleteVenueTag = async (tagId: number): Promise<SimpleStringResponse> =>
  sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/venue-tag?tagId=${encodeURIComponent(String(tagId))}`,
  );
